module.exports = __webpack_public_path__ + "img/lines-active.20a05a99.svg";